import React from "react";
import Image from "next/image";

export default function Search({ search, handleChange }) {
  return (
    <div className="flex h-11 w-full items-center space-x-2 rounded-xl bg-white py-2 px-6 shadow-[4px_4px_4px_0_rgba(0,0,0,0.05)] shadow-[#92A5C6] md:w-3/4">
      <Image
        src="/images/search.svg"
        alt="search"
        width={16}
        height={16}
        priority={true}
      />
      <input
        type="text"
        name="search"
        id="search"
        className="w-full font-nunito text-base font-semibold text-[#7F7F7F] focus:outline-none "
        placeholder="Masukkan Pencarian"
        value={search}
        onChange={handleChange}
      />
    </div>
  );
}
